// import logo from './logo.svg';
import './App.css';
import React from 'react';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import Home from './pages/Home';

const theme = extendTheme({
  fonts: {
    body: 'Inter, -apple-system, system-ui, sans-serif',
    heading: 'Inter, -apple-system, system-ui, sans-serif',
  },
  styles: {
    global: {
      'html, body': {
        backgroundColor: 'white',
        minHeight: '100%',
      },
      body: {
        bg: 'white',
        color: '#1a1a1a',
      },
    },
  },
  components: {
    Link: {
      baseStyle: {
        color: '#1a1a1a',
        textDecoration: 'none',
        _hover: {
          textDecoration: 'none',
          color: 'gray.600',
          transition: 'all 0.2s ease-in-out',
        },
      },
    },
    Text: {
      baseStyle: {
        letterSpacing: '-0.02em',
        fontFeatureSettings: '"salt" 1, "ss01" 1, "ss02" 1', // Enable stylistic alternates for Switzer
      },
    },
  },
});

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Home />
    </ChakraProvider>
  );
}

export default App;
